import {PeopleType} from "src/app/enums/People";

/** Role labels shared by the back-office and the public entity filters. */
export const PEOPLE_TYPE_LABELS: Record<PeopleType, string> = {
  [PeopleType.Creator]: "ADMIN_PEOPLE_TYPE_CREATOR",
  [PeopleType.Author]: "ADMIN_PEOPLE_TYPE_AUTHOR",
  [PeopleType.Contributor]: "ADMIN_PEOPLE_TYPE_CONTRIBUTOR",
  [PeopleType.Director]: "ADMIN_PEOPLE_TYPE_DIRECTOR",
  [PeopleType.Actor]: "ADMIN_PEOPLE_TYPE_ACTOR",
  [PeopleType.Artist]: "ADMIN_PEOPLE_TYPE_ARTIST",
  [PeopleType.Composer]: "ADMIN_PEOPLE_TYPE_COMPOSER",
  [PeopleType.Screenwriter]: "ADMIN_PEOPLE_TYPE_SCREENWRITER",
  [PeopleType.Producer]: "ADMIN_PEOPLE_TYPE_PRODUCER",
};
